// extracted by mini-css-extract-plugin
export default {"celebrate":"banner4_celebrate__nTdF7","celebrate_back":"banner4_celebrate_back__wmX6V"};